import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    marginTop: 10,
    marginBottom: 0,
  },
  reportTitle: {
    color: '#000000',
    fontSize: 12,
    flexDirection: 'row',
  },
  agent: {
    color: '#000000',
    fontSize: 10,
    flexDirection: 'row',
  },
  row: {
    flexDirection: 'row',
  },
});

const Argent = () => (
  <View style={styles.titleContainer}>
    <View style={styles.row}>
      <Text style={styles.reportTitle}>Argent Realty</Text>
    </View>
  </View>
);

export default Argent;
